import { Link, Head, usePage, Deferred } from '@inertiajs/react'
import { Button } from "@/components/ui/button"
import { ColumnDef } from "@tanstack/react-table"
import { Plus } from "lucide-react"
import { FlashMessage } from '@/components/flash-message'
import { SortableHeader } from '@/components/sortable-header'
import { FilteredTable } from '@/components/ui/filtered-table'
import { Agent } from '@/types/serializers'


interface Props {
  agents: Agent[]
  [key: string]: any
}

const columns: ColumnDef<Agent>[] = [
  {
    accessorKey: "name",
    header: ({ column }) => <SortableHeader column={column} title="Name" />,
    enableSorting: true,
    cell: ({ row }) => {
      const agent = row.original
      return (
        <Link href={`/agents/${agent.id}`} className="hover:underline">
          {agent.name}
        </Link>
      )
    }
  },
  {
    accessorKey: "email",
    header: ({ column }) => <SortableHeader column={column} title="Email" />,
    enableSorting: true,
  },
  {
    accessorKey: "phone",
    header: ({ column }) => <SortableHeader column={column} title="Phone" />,
    enableSorting: true,
  },
  {
    accessorKey: "salesforce_id",
    header: "Salesforce ID",
  },
  {
    id: "actions",
    cell: ({ row }) => {
      const agent = row.original
      return (
        <div className="flex items-center gap-2">
          <Link href={`/agents/${agent.id}`}>
            <Button variant="outline" size="sm">
              View
            </Button>
          </Link>
          <Link href={`/agents/${agent.id}/edit`}>
            <Button variant="outline" size="sm">
              Edit
            </Button>
          </Link>
        </div>
      )
    },
  },
]

export default function Index() {
  const { agents } = usePage<Props>().props

  return (
    <>
      <Head title="Agents" />
        <div className="space-y-4 pt-4 px-6">
          <div className="flex items-center justify-between">
            <h1 className="text-3xl font-bold">Agents</h1>
            <Link href="/agents/new">
              <Button>
                <Plus className="mr-2 h-4 w-4" />
                New Agent
              </Button>
            </Link>
          </div>
        </div>

        <FlashMessage />

        <div className="p-6">
          <Deferred data="agents" fallback={<div>Loading...</div>}>
            <FilteredTable
              data={agents}
              columns={columns}
              searchPlaceholder="Search agents..."
            />
          </Deferred>
      </div>
    </>
  )
}
